document.addEventListener("DOMContentLoaded", function () {
  if(window.location.pathname == "/cart"){
    setInterval(() => {
      document.querySelectorAll('.tee-cart-thumbnail__link').forEach(thumb => {
        thumb.removeAttribute('target');
        thumb.removeAttribute('href');
        thumb.onclick = clickPreview;
        setTimeout(() => {
          var checkoutBtn = document.createElement('a');
          checkoutBtn.setAttribute('href','/checkout');
          checkoutBtn.innerText = 'Proceed To Checkout';
          checkoutBtn.classList = 'tee-checkout'
          if(document.querySelector('.tee-dcontent-body') && document.querySelector('.tee-dcontent-body .tee-checkout') == null){
            document.querySelector('.tee-dcontent-body').append(checkoutBtn)
          }
          if(document.querySelector('.tee-dcontent-body .tee-customization-image__link')){
            document.querySelector('.tee-dcontent-body .tee-customization-image__link').removeAttribute('href');
            document.querySelector('.tee-dcontent-body .tee-customization-image__link').removeAttribute('target');
          }
        },1000)
      })
    },100)
  }
})
window.clickPreview = (e) => {
  var previewBtn = e.currentTarget.closest('.cart-item').querySelector('.tee-preview-button');
  if(previewBtn){
    previewBtn.click()
  }
}
// EZ S7i: keep exactly one sale badge in the Teeinblue price block, computed from the
// prices on screen (works in every currency). No compare-at price -> no badge.
function ezSaleBadge() {
  var box = document.querySelector("#tee-artwork-form .tee-product-price") || document.querySelector(".tee-block.tee-product-price");
  if (!box) return;
  var badges = box.querySelectorAll(".price__badge-sale");
  for (var i = 1; i < badges.length; i++) badges[i].remove();
  var badge = badges[0] || null;
  var cmpEl = box.querySelector(".tee-price--compare");
  var curEl = box.querySelector(".tee-price--current");
  var pct = 0;
  if (cmpEl && curEl) {
    var c = parseFloat(cmpEl.textContent.replace(/[^\d]/g, ""));
    var p = parseFloat(curEl.textContent.replace(/[^\d]/g, ""));
    if (c > 0 && p >= 0 && c > p) pct = Math.floor(((c - p) / c) * 100);
  }
  if (pct < 1) { if (badge) badge.remove(); return; }
  if (!badge) {
    badge = document.createElement("span");
    badge.className = "badge price__badge-sale color-scheme-4";
    box.appendChild(badge);
  }
  var text = "Save " + pct + "%";
  if (badge.textContent !== text) badge.textContent = text;
}
function init () {
  const deliver = document.querySelector(".deliver-to-country-line");
  const shipping = document.querySelector(".new-shipping");
  const modalShipping = document.querySelector('.modal-shipping[data-index="1"]');
  const boxCutOff = document.querySelector(".box-cut-off");
  const boxCutOff2 = document.querySelector(".box-cut-off2");
  const quantity = document.querySelector(".tee-quantity");
  const checkbox = document.querySelector(".tee-checkbox-wrapper");
  var optionLabel = document.querySelectorAll(".tee-radio-label");
  if(modalShipping){
    document.addEventListener("click", (event) => {
      // Check if the clicked target is INSIDE the specific element
      if (!document.querySelector('.new-shipping').contains(event.target)) {
          modalShipping.classList.remove('show')
      }else{
        modalShipping.classList.add('show')
      }
  });
    document.querySelector('.icon-closed-fulfillment').addEventListener('click',() => {
      modalShipping.classList.remove('show')
    })
  }
  const insertAfterElement = document.querySelector(
    ".tee-block.tee-product-price"
  ) || document.querySelector('[id*="price-template--"]')
  
  if(boxCutOff2 && insertAfterElement){
    insertAfterElement.after(boxCutOff2);
  }
  if(boxCutOff && insertAfterElement){
    insertAfterElement.after(boxCutOff);
  }
  if (shipping && insertAfterElement) {
    insertAfterElement.after(shipping);
  }
  if (shipping && modalShipping && window.innerWidth >= 768) {
    shipping.after(modalShipping);
  }
  if (deliver && insertAfterElement) {
    insertAfterElement.after(deliver);
  }
  if(document.querySelector('shopify-payment-terms') != null && deliver){
    deliver.before(document.querySelector('shopify-payment-terms'))
  }
  // EZ S7i: one "Save X%" badge only, never a bare "Sale" badge (init() can run twice:
  // DOMContentLoaded + teeinblue-event-component-injected).
  ezSaleBadge();
  var quantityBox = document.createElement("div");
  quantityBox.classList = "product-form__input product-form__quantity custom";
  quantityBox.innerHTML = `<label class="quantity__label form__label" for="Quantity-template--17603437789340__main">
    Quantity
    <span class="quantity__rules-cart no-js-hidden hidden">
      <span class="loading-overlay hidden">
        <span class="loading-overlay__spinner">
          <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </span>
      </span>
      
      
    </span>
  </label>`;
  if (document.getElementById("teeFormActions") != null && quantity != null) {
    document.getElementById("teeFormActions").append(quantityBox);
    document
      .getElementById("teeFormActions")
      .classList.add("tee-form-actions--no-sticky");
  }
  const createSizeChart = () => {
    document.querySelectorAll('.tee-option__title').forEach(title => {
      var has_size_chart = false;
      has_size_chart = window.product.tags.some(tag => window.size_chart_tags.indexOf(tag) != -1)
      if((title.innerText == "SIZE" || title.innerText == "Size" || title.innerText == "size" || title.innerText == "Choose Your Size") && has_size_chart){
        var size_chart_btn = document.createElement('div'); 
        size_chart_btn.classList = 'js-btn-show-size-chart';
        size_chart_btn.innerHTML = `<label class="toggle-modal-size-chart" for="toggle-modal-size-chart">
          <span>Size Chart</span>
        </label>`
        title.appendChild(size_chart_btn)
      }
    })
  }
  createSizeChart()
  if (document.getElementById("teeFormInputs") != null) {
    if (quantity != null) {
      document.getElementById("teeFormInputs").after(quantityBox);
    }
    if (
      document.body.classList.contains("teeinblue-platform-product-enabled")
    ) {
      var teeFormActions = document.createElement("div");
      teeFormActions.id = "teeFormActions";
      teeFormActions.classList =
        "tee-form-actions tee-block tee-form-actions--no-sticky";
      document.getElementById("teeFormInputs").after(teeFormActions);
      if (document.querySelector(".product-form__quantity") != null) {
        document
          .getElementById("teeFormActions")
          .appendChild(document.querySelector(".product-form__quantity"));
        document
          .getElementById("teeFormActions")
          .appendChild(document.querySelector(".tee-campaign-form-footer"));
        document
          .getElementById("teeFormActions")
          .appendChild(document.querySelector(".product-form__submit"));
      }
    }
  }
  if (checkbox != null) {
    checkbox.after(quantityBox);
  }
  if (quantity != null) {
    document.querySelector(".quantity__label").after(quantity);
  }
  if (window.__ezTeeTick) clearInterval(window.__ezTeeTick); // EZ S7i: never run two 100ms loops
  var myInterval = window.__ezTeeTick = setInterval(function () {
    ezSaleBadge();
    if(document.querySelectorAll(".tee-radio-label").length){
      optionLabel = document.querySelectorAll(".tee-radio-label");
      bestSelling()
    }
    if(document.querySelector('.tee-option__title .js-btn-show-size-chart') == null){
      createSizeChart()
    }
  }, 100);
  const bestSelling = () => {
    optionLabel.forEach((label) => {
      if(label.querySelector('.linhnn-bagde-option') == null){
        var labelObject = window.product.list_label.find(ob => ob.option == label.title);
        if (labelObject != null) {
          var div = document.createElement("div");
          div.classList = `linhnn-bagde-option ${labelObject.label.toLowerCase().replaceAll(' ','-')}`;
          div.innerText = labelObject.label;
          label.appendChild(div);
        }
      }
    });
  }
  bestSelling()
  if (
    document.querySelector(".product__info-container") != null &&
    document.querySelector(".btn-preview[data-ez-tee]") == null // EZ S7i: add this bar only once
  ) {
    var preview = document.createElement("div");
    preview.classList = "btn-preview hidden-xl";
    preview.setAttribute("data-ez-tee", "");
    preview.innerHTML = `<a id="btn-preview" onclick="document.querySelector('.tee-btn--preview').click()" class="button customily-preview-button">Preview Your Personalization</a>`;
    document.querySelector(".product__info-container").appendChild(preview);
    document.getElementById("btn-preview").addEventListener("click", (e) => {
      e.preventDefault();
      // var scrollDiv = document.getElementById("teeFormActions").offsetTop;
      // window.scrollTo({ top: scrollDiv, behavior: "smooth" });
      document.querySelector('.tee-btn--preview').click()
    });
    // if (isElementVisible(document.getElementById("teeFormActions"))) {
    //   document.querySelector(".btn-preview").classList.add("hidden");
    // } else {
    //   document.querySelector(".btn-preview").classList.remove("hidden");
    // }
    // window.addEventListener("scroll", () => {
    //   if (isElementVisible(document.getElementById("teeFormActions"))) {
    //     document.querySelector(".btn-preview").classList.add("hidden");
    //   } else {
    //     document.querySelector(".btn-preview").classList.remove("hidden");
    //   }
    // });
  }
  if(document.querySelector('.tee-btn--personalize') != null && !document.querySelector('.tee-btn--personalize').dataset.ezBound){
    document.querySelector('.tee-btn--personalize').dataset.ezBound = '1';
    document.querySelector('.tee-btn--personalize').addEventListener('click',() => {
      setTimeout(() => {
        document.querySelector('.tee-btn--preview').click()
      },500)
    })
  }
  function isElementVisible(el) {
    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight ||
          document.documentElement.clientHeight) /* or $(window).height() */ &&
      rect.right <=
        (window.innerWidth ||
          document.documentElement.clientWidth) /* or $(window).width() */
    );
  }
  if (document.getElementById("teeFormInputs") != null && document.querySelector('.title-customize') == null) {
    var title = document.createElement("span");
    title.classList = "title-customize";
    title.innerText = "PERSONALIZED";
    document.getElementById("teeFormInputs").prepend(title);
    var guide = document.createElement("p");
    guide.classList = "upload_image_guidelines";
    guide.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg><span style="padding-left: 5px;">View photo upload guidelines here</span>`;
    title.after(guide);
  }
  const classClosePhoto = [
    ".closed-photo-image",
    ".upload_image_guidelines",
    ".closed-bg-photo",
  ];
  classClosePhoto.forEach(function (nameClass) {
    var element = document.querySelector(nameClass);
    if (element) {
      if(nameClass.includes('closed')){
        element.addEventListener("click", function () {
          document
            .querySelector(".modal-custom-image")
            .classList.add("hidden");
          document.querySelector(".closed-bg-photo").classList.add("hidden");
        });
      }else{
        element.addEventListener("click", function () {
          document
            .querySelector(".modal-custom-image")
            .classList.remove("hidden");
          document.querySelector(".closed-bg-photo").classList.remove("hidden");
        });
      }
    }
  });
  if(document.querySelector('.tee-btn--preview') != null && !document.querySelector('.tee-btn--preview').dataset.ezBound){
    document.querySelector('.tee-btn--preview').dataset.ezBound = '1';
    document.querySelector('.tee-btn--preview').addEventListener('click', function(){
      var myInterval = setInterval(() => {
        if(document.querySelector('.tee-dcontent-body:not(.tee-image-placement-body) .tee-preview__mockup') != null && document.querySelector('.tee-dcontent-body:not(.tee-image-placement-body) .tee-preview__mockup h3') == null){
          var h3 = document.createElement('h3');
          h3.innerText = 'Please check the preview carefully'
          var p = document.createElement('p');
          p.classList = 'sub-content'
          p.innerText = 'Make sure the below customization is correct to receive your item faster'
          document.querySelector('.tee-dcontent-body:not(.tee-image-placement-body) .tee-preview__mockup').prepend(p)
          document.querySelector('.tee-dcontent-body:not(.tee-image-placement-body) .tee-preview__mockup').prepend(h3)
          clearInterval(myInterval)
        }
      },100)
    })
  }
}
document.addEventListener("teeinblue-event-component-injected", init)
document.addEventListener("DOMContentLoaded", init)